import type { ReactNode } from 'react';
import { ConfirmActionModal } from '@/shared/components';

interface Props {
  isOpen: boolean;
  title: string;
  message: ReactNode;
  confirmLabel: string;
  confirmVariant?: 'danger' | 'warning' | 'primary';
  isPending: boolean;
  error: string | null;
  onConfirm: () => void;
  onClose: () => void;
}

export function TemplateActionConfirm({ error, message, ...modalProps }: Props) {
  return (
    <ConfirmActionModal
      {...modalProps}
      message={
        <>
          <p>{message}</p>
          {error && (
            <p role="alert" className="mt-3 text-mp-error">
              {error}
            </p>
          )}
        </>
      }
    />
  );
}
